/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_suggestion_to_enable_in_depth_search_text35 = /** @type {(inputs: {}) => string} */ () => {
	return `Cannot find what you looked for? Try to enable in-depth search to include content`
};

const fr_suggestion_to_enable_in_depth_search_text35 = /** @type {(inputs: {}) => string} */ () => {
	return `Vous ne trouvez pas ce que vous cherchiez ? Essayez d'activer la recherche en profondeur pour montrer l'intérieur des resources`
};

const de_suggestion_to_enable_in_depth_search_text35 = /** @type {(inputs: {}) => string} */ () => {
	return `Können Sie nicht finden, wonach Sie gesucht haben? Versuchen Sie, die Tiefensuche zu aktivieren, um Inhalte einzubeziehen`
};

const es_suggestion_to_enable_in_depth_search_text35 = /** @type {(inputs: {}) => string} */ () => {
	return `¿No encuentras lo que buscas? Intenta habilitar la búsqueda en profundidad para incluir contenido`
};

const it_suggestion_to_enable_in_depth_search_text35 = /** @type {(inputs: {}) => string} */ () => {
	return `Non riesci a trovare quello che cerchi? Prova ad abilitare la ricerca approfondita per includere contenuti`
};

const ar_suggestion_to_enable_in_depth_search_text35 = /** @type {(inputs: {}) => string} */ () => {
	return `ألا يمكنك العثور على ما بحثت عنه؟حاول تمكين البحث المتعمق لتضمين المحتوى`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const suggestion_to_enable_in_depth_search_text35 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.suggestion_to_enable_in_depth_search_text35(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("suggestion_to_enable_in_depth_search_text35", locale)
	if (locale === "en") return en_suggestion_to_enable_in_depth_search_text35(inputs)
	if (locale === "fr") return fr_suggestion_to_enable_in_depth_search_text35(inputs)
	if (locale === "de") return de_suggestion_to_enable_in_depth_search_text35(inputs)
	if (locale === "es") return es_suggestion_to_enable_in_depth_search_text35(inputs)
	if (locale === "it") return it_suggestion_to_enable_in_depth_search_text35(inputs)
	return ar_suggestion_to_enable_in_depth_search_text35(inputs)
};
export { suggestion_to_enable_in_depth_search_text35 as "SUGGESTION_TO_ENABLE_IN_DEPTH_SEARCH_TEXT" }